var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValorantLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 12L24 44V84L64 116L104 84V44L64 12Z",
    fill: "#FF4655"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 20L32 48V80L64 108L96 80V48L64 20Z",
    fill: "#0F1923"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 28L40 52V76L64 100L88 76V52L64 28Z",
    fill: "#FF4655"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64 36L48 56V72L64 92L80 72V56L64 36Z",
    fill: "#0F1923"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60L56 68V72L64 80L72 72V68L64 60Z",
    fill: "#FF4655"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValorantLogo);
export default __webpack_public_path__ + "static/media/valorant-logo.2b10f98ea3b30db5f3696da25d683abe.svg";
export { ForwardRef as ReactComponent };